// rouletteUtils.js
export function calculateWinner(items, rotation) {
  const rand = Math.random();
  let cumulative = 0;
  let winnerIndex = -1;
  const probabilitySum = items.reduce((sum, i) => sum + i.probability, 0);

  for (let i = 0; i < items.length; i++) {
    cumulative += items[i].probability / probabilitySum;
    if (rand <= cumulative) {
      winnerIndex = i;
      break;
    }
  }

  if (winnerIndex === -1) winnerIndex = items.length - 1;
  const winner = items[winnerIndex];

  const totalVisualWeight = items.reduce((sum, item) => sum + item.visualWeight, 0);
  let currentAngle = 0;
  let winnerStartAngle = 0;
  let winnerEndAngle = 0;

  for (let i = 0; i < items.length; i++) {
    const angle = (items[i].visualWeight / totalVisualWeight) * 360;
    if (i === winnerIndex) {
      winnerStartAngle = currentAngle;
      winnerEndAngle = currentAngle + angle;
      break;
    }
    currentAngle += angle;
  }

  const randomTargetAngle = winnerStartAngle + Math.random() * (winnerEndAngle - winnerStartAngle);
  const pointerAngle = 270;
  const extraSpins = 360 * (7 + Math.floor(Math.random() * 4));
  const effectiveRotation = rotation % 360;
  const correction = (360 - randomTargetAngle + pointerAngle - effectiveRotation + 360) % 360;
  const finalRotation = rotation + extraSpins + correction;

  return { winner, finalRotation };
}
